import React from 'react';
export function ShoppingCartIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.281 20.269a1 1 0 101.413 1.414 1 1 0 00-1.413-1.414zM18.281 20.284a1 1 0 101.413 1.414 1 1 0 00-1.413-1.414zM21 12.966L21.007 7a2 2 0 00-2-2L7.146 4.975l-.013-.2A3.007 3.007 0 004.145 1.97H3.014a1 1 0 000 2h1.127a1 1 0 011 .935l.652 10v.012l.081 1.251a3.01 3.01 0 002.99 2.8l11.129.017a1 1 0 100-2l-11.129-.008a1 1 0 01-1-.935l-.018-.27 11.293-.814A2.008 2.008 0 0021 12.966zm-2 0l-11.28.812-.442-6.8 11.73.017L19 12.966z"
  }));
}